import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isWhiteLabled } from '../../utils/URL';
import { screens as whiteLabeledScreens } from '../../whitelabelScreenConfiguration';
import { isLoggedIn } from '../../utils/AthuService';
import store from '../../sessionStorage';
import { PATH } from '../../utils/Constants';
import { RESPONSE_CONSTANT } from '../ResponseConstant';
import { Student, Tutor } from '../common/NamingTerms';
/**
 * RedirectRoute
 */
export const RedirectRoute = ({ ...rest }) => <Redirect {...rest} />;

/**
 * PatientRoute
 */
export const PatientRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('userSession').role === 'PARENT' ||
                store.get('userSession').role === Student ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

/**
 * PhysicianRoute
 */
export const PhysicianRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('userSession').role === Tutor ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

/**
 * SuperAdminRoute
 */
export const InsSuperAdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('insAdminSession').role === 'GRA_ADMIN' ? (
                    <Component {...rest} {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

export const BranchAdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN ? (
                    <Component {...rest} {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

export const LevelOneAdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_ONE_ADMIN ? (
                    <Component {...rest} {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

export const LevelTwoAdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ? (
                    <Component {...rest} {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

/**
 * PrivateRoute
 */
export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedIn() ? (
                store.get('userSession') ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={PATH.INDEX} />
                )
            ) : (
                <Redirect to={PATH.INDEX} />
            )
        }
    />
);

/**
 * PublicRoute
 */
export const PublicRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => <Component {...props} />} />
);

/**
 * CustomWhitelabelRoute
 */
export const CustomWhitelabelRoute = ({ screen, ...props }) => {
    let screenObject = whiteLabeledScreens.find((whiteLabeledScreenObject) => {
        return (
            whiteLabeledScreenObject.whiteLabeled === isWhiteLabled &&
            whiteLabeledScreenObject.screen === screen
        );
    });
    return <Route {...props} component={screenObject.component} />;
};
